// extracted by mini-css-extract-plugin
export const root = "Content-module--root--2dAOT";
export const row = "Content-module--row--1myV4";
export const inner = "Content-module--inner--Z27f5";
export const description = "Content-module--description--13AW4";
export const header = "Content-module--header--oSwUQ";
export const content = "Content-module--content--2u2Cz";